import * as DomBuilder from "./dom-builder.js";
import * as Utils from "./utils.js";
import Filters from "../Filters.js";
import DialogDetails from "./DialogDetails.js";

/**
 * @version 2026-09-03
 * @author Patrik Harag
 */
export default class DialogStats {

    /** @type {Controller} */
    #controller;
    /** @type {Transaction[]} */
    #transactions;
    /** @type {string} */
    groupName;
    /** @type {Map<string,Filter>} */
    #filters;

    /**
     *
     * @param controller {Controller}
     * @param groupName {string}
     * @param transactions {Transaction[]}
     * @param filters {Map<string,Filter>}
     */
    constructor(controller, groupName, transactions, filters) {
        this.#controller = controller;
        this.groupName = groupName;
        this.#transactions = transactions;
        this.#filters = filters;
    }

    show() {
        let dialog = DomBuilder.bootstrapDialogBuilder();
        dialog.setHeaderContent(this.groupName + ' Summary');
        dialog.setBodyContent(this.#buildBody());
        dialog.addCloseButton('Close');
        dialog.setSizeLarge();
        dialog.show(this.#controller.getDialogAnchor());
    }

    #buildBody() {
        let filterGroups = Filters.groupByFilters(this.#transactions, this.#filters, "Others");

        let tableBody = DomBuilder.element('tbody');
        let table = DomBuilder.div({ class: 'table-responsive' }, [
            DomBuilder.element('table', { class: 'table table-striped' }, tableBody)
        ]);

        let totalExpenses = 0;
        let totalReceipts = 0;
        for (let filterGroup of filterGroups.values()) {
            if (filterGroup.transactions.length === 0) {
                continue;
            }

            let expensesTransactions = filterGroup.transactions.filter(t => t.getValue() < 0);
            let receiptsTransactions = filterGroup.transactions.filter(t => t.getValue() > 0);
            let expenses = expensesTransactions.reduce((sum, t) => sum + t.getValue(), 0);
            let receipts = receiptsTransactions.reduce((sum, t) => sum + t.getValue(), 0);
            let result = receipts + expenses;

            totalExpenses += expenses;
            totalReceipts += receipts;

            let detailsButton = DomBuilder.link('', { class: 'fa fa-eye' }, () => {
                let dialog = new DialogDetails(this.#controller, this.groupName + ' / ' + filterGroup.filter.getName(),
                        filterGroup.transactions, filterGroup.filter, this.#filters);
                dialog.show();
            });

            let row = DomBuilder.element('tr', null, [
                DomBuilder.element('td', null, filterGroup.others
                    ? DomBuilder.span(filterGroup.filter.getName())
                    : Utils.createFilterLabel(filterGroup.filter)),
                DomBuilder.element('td', { class: 'value-cell positive' }, Utils.createFxValue(receipts, receiptsTransactions)),
                DomBuilder.element('td', { class: 'value-cell negative' }, Utils.createFxValue(expenses, expensesTransactions)),
                DomBuilder.element('td', { class: `value-cell result ${result < 0 ? 'negative' : 'positive'}` },
                    Utils.createFxValue(result, filterGroup.transactions)),
                DomBuilder.element('td', { class: 'options-cell' }, detailsButton)
            ]);

            tableBody.append(row);
        }

        let result = totalReceipts + totalExpenses;
        tableBody.append(DomBuilder.element('tr', null, [
            DomBuilder.element('td', { class: 'result' }, '∑'),
            DomBuilder.element('td', { class: 'value-cell result positive' }, Utils.createFxValue(totalReceipts, this.#transactions.filter(t => t.getValue() > 0))),
            DomBuilder.element('td', { class: 'value-cell result negative' }, Utils.createFxValue(totalExpenses, this.#transactions.filter(t => t.getValue() < 0))),
            DomBuilder.element('td', { class: `value-cell result ${result < 0 ? 'negative' : 'positive'}` }, Utils.createFxValue(result, this.#transactions)),
            DomBuilder.element('td')
        ]));

        return table;
    }

}
